import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api } from "@/lib/api";

export default function ExportData() {
  const [busy, setBusy] = useState(false);

  const exportCms = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/export.json", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/json" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `abbotasia-cms-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success("CMS JSON downloaded.");
    } catch (err) {
      toast.error("Could not export.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-export">
      <p className="eyebrow">Maintenance</p>
      <h1 className="mt-3 font-serif text-4xl text-jade font-light">Export &amp; backup</h1>
      <p className="mt-3 text-ink/65 text-[14px] font-light max-w-2xl">
        Download a snapshot of all editable website content as a single JSON file. Useful before code updates, when handing the project to a developer, or as a quick off-machine backup.
      </p>

      <div className="mt-12 space-y-6 max-w-2xl">
        <div className="border border-mist p-6">
          <p className="font-serif text-xl text-jade">CMS content (JSON)</p>
          <p className="mt-2 text-[13px] text-ink/65 leading-relaxed">
            Includes site settings, pages, SEO, destinations, journeys, journal, testimonials, team and media metadata. Image files themselves are <em>not</em> in this archive — back them up separately from the uploads folder. <strong>Enquiries are excluded by design.</strong>
          </p>
          <div className="mt-5">
            <button
              type="button"
              onClick={exportCms}
              disabled={busy}
              data-testid="export-cms"
              className="btn-primary inline-flex items-center gap-2 disabled:opacity-40"
            >
              <Download size={14} /> {busy ? "Preparing…" : "Download CMS JSON"}
            </button>
          </div>
        </div>

        <div className="border border-mist p-6">
          <p className="font-serif text-xl text-jade">Enquiries (CSV)</p>
          <p className="mt-2 text-[13px] text-ink/65 leading-relaxed">
            Enquiries are exported separately. Use the <strong>Export CSV</strong> button inside <em>Enquiries</em> to download every submission with status and internal notes.
          </p>
        </div>

        <div className="border border-mist p-6 bg-sand/30">
          <p className="font-serif text-xl text-jade">Server-side maintenance</p>
          <p className="mt-2 text-[13px] text-ink/65 leading-relaxed">
            For full database dumps, image-folder backups, and restore procedures, see <code className="text-jade">/MAINTENANCE.md</code> in the repository.
          </p>
        </div>
      </div>
    </div>
  );
}
